import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Person, LocationOn } from "@material-ui/icons";
import classNames from "classnames";
import { Tooltip, IconButton, Hidden, Button } from "@material-ui/core";
import styles from "style";
import PopoverMenu from "./PopoverMenu";
import {
  LOCATION_POPUP_MENU,
  ONLINE_BANKING_POPUP_MENU,
  ACCOUNT_LOGIN_POPUP_MENU,
} from "./popeverMenus";
import NavMenus from "./NavMenus";

const NavBarRightSection = ({ classes, data, openItem, setOpenItem }) => {
  const [locationPopoverOpen, setLocationPopOverOpen] = useState(false);
  const [onlineBankingOpen, setOnlineBankingOpen] = useState(false);
  const [accountOpeningOpen, setAccountOpeningOpen] = useState(false);
  const [locationRef, setLocationRef] = useState(null);
  const [accountOpeningRef, setAccountOpeningRef] = useState(null);
  const [onlineBankingRef, setOnlineBankingRef] = useState(null);

  const onLocationClick = (event) => {
    setLocationRef(event.currentTarget);
    setLocationPopOverOpen((prev) => !prev);
  };
  const closeLocationPopOver = () => {
    setLocationRef(null);
    setLocationPopOverOpen(false);
  };
  const onOnlineBankingClick = (event) => {
    setOnlineBankingRef(event.currentTarget);
    setOnlineBankingOpen((prev) => !prev);
  };
  const closeOnlineBankingPopOver = () => {
    setOnlineBankingOpen(false);
    setOnlineBankingRef(null);
  };
  const onAccountOpeningClick = (event) => {
    setAccountOpeningRef(event.currentTarget);
    setAccountOpeningOpen((prev) => !prev);
  };
  const closeAccountOpeningPopOver = () => {
    setAccountOpeningOpen(false);
    setAccountOpeningRef(null);
  };
  return (
    <div className={classNames(classes.navRight, "flex-direction-row")}>
      <NavMenus data={data} openItem={openItem} setOpenItem={setOpenItem} />
      <Hidden smDown>
        <Tooltip title="EastWest Stores & ATMs">
          <IconButton
            color="secondary"
            ref={locationRef}
            aria-owns={locationPopoverOpen ? "menu-list-grow" : null}
            aria-haspopup="true"
            onClick={onLocationClick}
          >
            <LocationOn color="primary" />
          </IconButton>
        </Tooltip>
      </Hidden>
      <PopoverMenu
        anchorRef={locationRef}
        items={LOCATION_POPUP_MENU}
        closePopover={closeLocationPopOver}
        popoverOpen={locationPopoverOpen}
      />
      <Hidden mdUp>
        <Tooltip title="Account Login">
          <IconButton
            color="secondary"
            ref={accountOpeningRef}
            aria-owns={accountOpeningOpen ? "menu-list-grow" : null}
            aria-haspopup="true"
            onClick={onAccountOpeningClick}
          >
            <Person color="primary" />
          </IconButton>
        </Tooltip>
        <PopoverMenu
          anchorRef={accountOpeningRef}
          items={ACCOUNT_LOGIN_POPUP_MENU}
          closePopover={closeAccountOpeningPopOver}
          popoverOpen={accountOpeningOpen}
        />
      </Hidden>
      <Hidden mdDown>
        <Button
          style={{ marginRight: "5px" }}
          variant="contained"
          color="secondary"
          ref={onlineBankingRef}
          aria-owns={onlineBankingOpen ? "menu-list-grow" : null}
          aria-haspopup="true"
          onClick={onOnlineBankingClick}
          id="btnonlinebanking"
          className="trackme"
        >
          <Person style={{ color: "white" }} /> ONLINE BANKING
        </Button>
        <PopoverMenu
          anchorRef={onlineBankingRef}
          items={ONLINE_BANKING_POPUP_MENU}
          popoverOpen={onlineBankingOpen}
          closePopover={closeOnlineBankingPopOver}
        />
      </Hidden>
    </div>
  );
};

export default withStyles(styles)(NavBarRightSection);
